module.exports = __webpack_public_path__ + "img/CardImage6.fc9f55de.png";